<template>
  <v-container fill-height
               fluid
               pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
  >
    <v-btn absolute
           color="white"
           class="rounded-lg"
           right
           text
           top
           @click="logout()"
    >Logout
    </v-btn>
    <v-container>
      <v-row align="center" justify="center" class="fill-height white--text" no-gutters>
        <v-col cols="auto">
          <v-row dense align="center" justify="center" class="fill-height">
            <v-col cols="12">
              <div class="display-3 white--text text-center">TDC Tools</div>
              <v-card class="mt-4" color="rgba(255,255,255,0.4)" :height="4"></v-card>
            </v-col>
            <v-col cols="12">
              <v-row justify="center" align="center">
                <v-col v-for="app in apps"
                       cols="auto"
                       :key="app.id"
                >
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card style="transition: all 0.15s;"
                              class="rounded-lg"
                              :width="350"
                              :color="hover ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.3)'"
                              :to="`/${app.id}/menu`"
                      >
                        <v-card-text class="white--text">
                          <v-row justify="space-between" no-gutters>
                            <div class="font-weight-bold title">{{ app.name }}</div>
                            <v-icon color="white">{{ app.icon }}</v-icon>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-6">
              <div class="display-3 white--text text-center">Other Tools</div>
              <v-card class="mt-4" color="rgba(255,255,255,0.4)" :height="4"></v-card>
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-col v-for="tool in tools"
                       cols="auto"
                       :key="tool.id"
                >
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card style="transition: all 0.15s;"
                              class="rounded-lg"
                              :width="350"
                              :color="hover ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.3)'"
                              :to="`/${tool.id}/menu`"
                      >
                        <v-card-text class="white--text">
                          <v-row justify="space-between" no-gutters>
                            <div class="font-weight-bold title">{{ tool.name }}</div>
                            <v-icon color="white">{{ tool.icon }}</v-icon>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import apps from '@/assets/general/apps.json';
import tools from '@/assets/general/other.json';

export default {
  name: "AppSelect",
  data: () => ({
    app: null,
    apps: null,
    tools: null,
    loading: false
  }),
  methods: {
    logout() {
      this.$store.dispatch('setAuthFalse').then(
          () => {
            this.$router.replace('/');
          }
      );
    }
  },
  mounted() {
    this.apps = apps;
    this.tools = tools;
  }
}
</script>

<style scoped>

</style>